export default function (data, timezones, languages) {
  this.$el = $('#userprefs');
  this.profile = ko.observable();

  this.timezones = ko.observableArray([]);

  this.selected_timezone = ko.computed({
    read: () => this.profile() ? this.profile().time_zone() : undefined,
    write: value => this.profile().time_zone(_.isUndefined(value) ? null : value)
  });

  this.languages = ko.observableArray([]);

  this.selected_language = ko.computed({
    read: () => this.profile() ? this.profile().locale() : undefined,
    write: value => this.profile().locale(_.isUndefined(value) ? null : value)
  });

  this.operating_systems = ko.observableArray(['Windows', 'Mac', 'Linux', 'Other']);

  this.selected_operating_system = ko.computed({
    read: () => {
      return this.profile() &&
        this.profile().preferences.operating_system ?
          this.profile().preferences.operating_system() :
          undefined;
    },

    write: value => {
      this.profile().preferences.operating_system(_.isUndefined(value) ? null : value);
    }
  });

  this.show_due_dates = ko.computed({
    read: () => {
      return this.profile() &&
        this.profile().preferences.hide_due_dates ?
          !this.profile().preferences.hide_due_dates() :
          true;
    },

    write: value => {
      this.profile().preferences.hide_due_dates(_.isUndefined(value) ? false : !value);
    }
  });

  this.showAccessibilityOptions = () => {
    $('#js-accessibility-options').addClass('active');
    $('#js-proctoring-options').removeClass('active');
  };

  this.showProctoringOptions = () => {
    $('#js-accessibility-options').removeClass('active');
    $('#js-proctoring-options').addClass('active');
  };

  this.bindData = (data, timezones, languages) => {
    const mappedProfile = ko.mapping.fromJS(
      data,
      {
        ignore: [
          'first_name',
          'last_name',
          'current_password',
          'password',
          'password_confirmation'
        ]
      }
    );

    this.profile(mappedProfile);

    if (timezones)
      this.timezones(timezones);

    if (languages)
      this.languages(languages);

    this.profile().preferences = ko.mapping.fromJS(data.preferences);

    new Array(
      'locale',
      'time_zone',
      'preferences.operating_system',
      'preferences.hide_due_dates',
      'preferences.alt_contrast',
      'preferences.proctoring.video_enabled',
      'preferences.proctoring.audio_enabled',
      'preferences.messenger.discoverable'
    ).forEach(keyPath => {
      const prop = Kadenze.Util.dig(this.profile(), keyPath);
      prop.subscribe(this.saveProfile)
    });
  };

  this.save = data => {
    const self = this;

    Kadenze.Ajax.patch({
      routeName: 'users',
      data,
      loadingContainer: this.$el,

      done: response => {
        if (response.reload)
          window.location.reload();

        new Kadenze.Notice.success({ message: I18n.t('dict.save_success') });

        document.querySelector('body').classList.toggle(
          'high-contrast',
          this.profile().preferences.alt_contrast()
        )
        $('.ajax-overlay').fadeOut(500);
      },

      fail: (xhr, status, msg) => {
        Kadenze.UIUtil.showNotice(this.$el, xhr.responseJSON, 3000);
      }
    });
  };

  this.saveProfile = () => {
    const clientErrors = ko.validation.group(this.profile(), { deep: true });

    if (clientErrors().length) {
      clientErrors.showAllMessages();
    } else {
      const mapping = { include: ['remove_avatar', 'remove_banner'] };
      const data = { user: ko.mapping.toJS(this.profile, mapping) };

      data.user.address_attributes = data.user.address;

      delete data.user.address;

      this.save(data);
    }
  };

  (() => this.bindData(data, timezones, languages))();
}
